export const uploaderImages = {
    front: require('../assets/images/Frente.png'),
    back: require('../assets/images/Atras.png'),
    leftSide: require('../assets/images/Lateral izquierdo.png'),
    rightSide: require('../assets/images/Lateral derecho.png'),
    interior: require('../assets/images/Foto interior.png'),
    video: require('../assets/images/video.png'),
    additional: require('../assets/images/adicional.png'),
};
